import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { createJpdExperience } from '../../utils/experience/main.tsx';
import type { JPDExperience } from '../../utils/experience/types.tsx';

export const pageSegmentLoad: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.fields-sidebar.load', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	}),
);

export const fieldToggle = createJpdExperience(
	new UFOExperience('jpd.fields-sidebar.field-toggle', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const fieldHide = createJpdExperience(
	new UFOExperience('jpd.fields-sidebar.field-hide', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const fieldDelete = createJpdExperience(
	new UFOExperience('jpd.fields-sidebar.field-delete', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const fieldRegularCreate = createJpdExperience(
	new UFOExperience('jpd.fields-sidebar.field-regular-create', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const fieldFormulaCreate = createJpdExperience(
	new UFOExperience('jpd.fields-sidebar.field-formula-create', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const fieldPlayCreate = createJpdExperience(
	new UFOExperience('jpd.fields-sidebar.field-play-create', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const fieldConfigurationUpdate = createJpdExperience(
	new UFOExperience('jpd.fields-sidebar.field-configuration-update', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

// create, delete and remove field option
export const fieldOptionUpdate = createJpdExperience(
	new UFOExperience('jpd.fields-sidebar.field-option-update', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);
